import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import FormateurFiche from '../pages/FormateurFiche';
import EspacePedagogique from '../pages/EspacePedagogique';
import logoStudmin from '../assets/logo-studmin.png';
import '../assets/styles/Layout.css';
import '../assets/styles/EspaceFormateur.css';

/**
 * Châssis d'un compte formateur : pas de barre latérale, deux vues seulement —
 * sa fiche, et l'espace pédagogique (les supports de l'équipe, en lecture
 * seule). Quelle que soit l'adresse demandée, il n'y a que cela ; le serveur,
 * lui, refuse de toute façon tout le reste (restreindreFormateur).
 */
const VUES = [
  { cle: 'fiche', label: 'Ma fiche' },
  { cle: 'pedagogie', label: 'Espace pédagogique' },
];

function LayoutFormateur() {
  const { utilisateur, deconnecter } = useAuth();
  const [vue, setVue] = useState('fiche');

  return (
    <div className="espace-formateur">
      <header className="espace-formateur-barre">
        <div className="espace-formateur-marque">
          <img className="espace-formateur-logo" src={logoStudmin} alt="Studmin" />
          <span className="espace-formateur-badge">Espace formateur</span>
        </div>

        <nav className="espace-formateur-nav" aria-label="Espace formateur">
          {VUES.map((v) => (
            <button
              key={v.cle}
              type="button"
              className={`espace-formateur-onglet${vue === v.cle ? ' espace-formateur-onglet-actif' : ''}`}
              aria-current={vue === v.cle ? 'page' : undefined}
              onClick={() => setVue(v.cle)}
            >
              {v.label}
            </button>
          ))}
        </nav>

        <div className="espace-formateur-compte">
          <span className="espace-formateur-nom" title={utilisateur?.email}>
            {utilisateur?.nom}
          </span>
          <button type="button" className="devis-btn devis-btn-sm" onClick={deconnecter}>
            Se déconnecter
          </button>
        </div>
      </header>

      <main className="espace-formateur-contenu">
        {vue === 'pedagogie' ? (
          <EspacePedagogique lectureSeule />
        ) : utilisateur?.formateur_id ? (
          <FormateurFiche formateurId={utilisateur.formateur_id} espaceFormateur />
        ) : (
          <div className="devis-state devis-state-error">
            Votre compte n’est rattaché à aucune fiche formateur. Contactez l’équipe.
          </div>
        )}
      </main>
    </div>
  );
}

export default LayoutFormateur;
